module.exports = __webpack_public_path__ + "static/media/ig.1d6a11bf.svg";